import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.discoverStepThreeLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.discoverStepThreeLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.discoverStepThreeLevels.data.discoverStepThreeLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
